import Link from 'next/link'
import Logo from './logo'
import { useTranslations } from 'next-intl'

export default function Footer() {
  const t = useTranslations("Landing")
  return (
    <footer>
      <div className="max-w-6xl mx-auto px-4 sm:px-6">

        {/* Blocks */}
        <div className="grid sm:grid-cols-12 gap-8 py-8 md:py-12">

          {/* 1st block */}
          <div className="sm:col-span-12 lg:col-span-4 order-1 lg:order-none">
            <div className="h-full flex flex-col sm:flex-row lg:flex-col justify-between">
              <div className="mb-4 sm:mb-0">
                <div className="mb-4">
                  <Logo />
                </div>
                <div className="text-sm text-slate-300">© Vexub <span className="text-slate-500">-</span> {t("toutDroit")}</div>
              </div>
              {/* Social links */}
              <ul className="flex">
                <li>
                  <a className="flex justify-center items-center text-purple-500 hover:text-purple-400 transition duration-150 ease-in-out" href="https://x.com/vexub_fr" aria-label="Twitter">
                    <svg className="w-8 h-8 fill-current" viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg">
                      <path d="m13.063 9 3.495 4.475L20.601 9h2.454l-5.359 5.931L24 23h-4.938l-3.866-4.893L10.771 23H8.316l5.735-6.342L8 9h5.063Zm-.74 1.347h-1.457l8.875 11.232h1.36l-8.778-11.232Z" />
                    </svg>
                  </a>
                </li>
              </ul>
            </div>
          </div>

          {/* 2nd block */}
          <div className="sm:col-span-6 md:col-span-3 lg:col-span-2">
            <h6 className="text-sm text-slate-50 font-medium mb-2">{t("service")}</h6>
            <ul className="text-sm space-y-2">
              <li>
                <a className="text-slate-400 hover:text-slate-200 transition duration-150 ease-in-out" href="#tarif">{t("nosTarif")}</a>
              </li>
            </ul>
            <h6 className="text-sm text-slate-50 font-medium my-2">{t("Caracteristiques")}</h6>
            <ul className="text-sm space-y-2">
              <li>
                <a className="text-slate-400 hover:text-slate-200 transition duration-150 ease-in-out" href="/veo3">{"VEO3"}</a>
              </li>
              <li>
                <a className="text-slate-400 hover:text-slate-200 transition duration-150 ease-in-out" href="/faceless-video-ai">{"Faceless Video"}</a>
              </li>
              <li>
                <a className="text-slate-400 hover:text-slate-200 transition duration-150 ease-in-out" href="/tiktok-ai">{"Tiktok AI"}</a>
              </li>
              <li>
                <a className="text-slate-400 hover:text-slate-200 transition duration-150 ease-in-out" href="/ai-video-generator">{"AI Video generator"}</a>
              </li>
            </ul>
          </div>

          {/* 3th block */}
          <div className="sm:col-span-6 md:col-span-3 lg:col-span-2" style={{ width: "max-content" }}>
            <h6 className="text-sm text-slate-50 font-medium mb-2">{t("legal")}</h6>
            <ul className="text-sm space-y-2">
              <li>
                <Link className="text-slate-400 hover:text-slate-200 transition duration-150 ease-in-out" href="/terms-of-use">{t("TitleCGU")} </Link>
              </li>
              <li>
                <Link className="text-slate-400 hover:text-slate-200 transition duration-150 ease-in-out" href="/privacy-policy">{t("ConfidTitle")}</Link>
              </li>
            </ul>
          </div>

          <div className="sm:col-span-6 md:col-span-3 lg:col-span-2" style={{ width: "max-content" }}>
            <h6 className="text-sm text-slate-50 font-medium mb-2">{t("Company")}</h6>
            <ul className="text-sm space-y-2">
              <li>
                <p className="text-slate-400 hover:text-slate-200 transition duration-150 ease-in-out">Company name: Vexub</p>
              </li>
              <li>
                <p className="text-slate-400 hover:text-slate-200 transition duration-150 ease-in-out">SIREN number: 980 146 419</p>
              </li>
              <li>
                <p className="text-slate-400 hover:text-slate-200 transition duration-150 ease-in-out">Address: 9 rue Jobbé Duval, 75015, Paris</p>
              </li>
            </ul>

          </div>



        </div>

      </div>

      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', flexFlow: 'column', gap: '5px' }}>
        <p style={{ textAlign: 'center', fontFamily: "sans-serif" }}>{t("Nos vidéos parlent grâce à notre partenaire ElevenLabs")}</p>
        <img src="https://vexub.fr/images/elevenlabsgrantt_white_c.webp?w=500&force_format=png" alt="ElevenLabs Logo" style={{ marginBottom: '50px', width: '60%', maxWidth: '500px' }} loading="lazy" />
      </div>

    </footer>
  )
}
